export default __webpack_public_path__ + "static/media/Diamond Front Left.489bd97b.png";